// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28wrr","left":"styles_left__-KLv7"};